module.exports = __webpack_public_path__ + "blog-2-teaser.jpg?f2acefa2e73fe8639fe97a14f774e207";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-2-teaser.jpg
// module id = 99
// module chunks = 0